import { commonLight } from '../../_styles/common';
const buttonGroupLight = {
    name: 'ButtonGroup',
    common: commonLight
};
export default buttonGroupLight;
